import React, { useRef, useState } from 'react';
import { Switch } from '../ui/switch';

export type MerchantDirectionField = 'deposit_enabled' | 'withdraw_enabled';

interface Props {
    depositEnabled?: boolean;
    withdrawEnabled?: boolean;
    readOnly: boolean;
    onChange: (field: MerchantDirectionField, enabled: boolean) => Promise<void>;
}

export const MerchantDirectionSwitches: React.FC<Props> = ({
    depositEnabled = true, withdrawEnabled = true, readOnly, onChange,
}) => {
    const savingRef = useRef(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const toggle = async (field: MerchantDirectionField, enabled: boolean) => {
        if (readOnly || savingRef.current) return;
        savingRef.current = true;
        setSaving(true);
        setError(null);
        try {
            await onChange(field, enabled);
        } catch (err: any) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === 'string' ? detail : 'Не удалось изменить доступность направления');
        } finally {
            savingRef.current = false;
            setSaving(false);
        }
    };

    return (
        <div className="px-6 pb-3" aria-busy={saving}>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                <label className="flex items-center gap-2 text-sm">
                    <Switch aria-label="Депозиты" checked={depositEnabled} disabled={readOnly || saving}
                        onCheckedChange={enabled => toggle('deposit_enabled', enabled)} />
                    Депозиты
                </label>
                <label className="flex items-center gap-2 text-sm">
                    <Switch aria-label="Выплаты" checked={withdrawEnabled} disabled={readOnly || saving}
                        onCheckedChange={enabled => toggle('withdraw_enabled', enabled)} />
                    Выплаты
                </label>
                {saving && <span role="status" className="text-xs text-slate-500">Сохранение…</span>}
            </div>
            {error && <p role="alert" className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>}
        </div>
    );
};
